import { PlusIcon } from '@phosphor-icons/react';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useLiveQuery } from 'dexie-react-hooks';

import { ICON_WEIGHT } from '@/components/icon';
import { Button } from '@/components/ui/button';
import { AircraftList } from '@/features/aircraft';
import { aircraft } from '@/lib/db';
import { formatCount } from '@/lib/format';

function AircraftIndexPage() {
  // `null` while the database is opening, distinct from zero aircraft —
  // `AircraftList` reports the loading state itself, so this only needs to
  // decide whether the "Add aircraft" button belongs in the header (once
  // there is already at least one record) or in the empty state below it.
  const count = useLiveQuery(() => aircraft.count(), [], null);

  return (
    <div className="mx-auto w-full max-w-3xl space-y-4">
      <div className="flex flex-wrap items-baseline justify-between gap-3">
        <h1 className="text-lg font-semibold tracking-tight">Aircraft</h1>
        {count === null || count === 0 ? null : (
          <Button size="sm" asChild>
            <Link to="/aircraft/new">
              <PlusIcon aria-hidden="true" weight={ICON_WEIGHT} className="size-4" />
              Add aircraft
            </Link>
          </Button>
        )}
      </div>
      {count === null || count === 0 ? null : (
        <p className="text-muted-foreground text-sm">{formatCount(count)} aircraft on record.</p>
      )}
      <AircraftList />
    </div>
  );
}

export const Route = createFileRoute('/aircraft/')({
  component: AircraftIndexPage,
});
